import React, { useRef, useState, useEffect } from "react";
import styles from "./ContactAssetNavigation.module.css";
import Button from "../../Button/Button";
import {
  DndContext,
  closestCenter,
  useSensor,
  useSensors,
  PointerSensor,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from '@dnd-kit/utilities';
import { useTranslation } from "react-i18next";
import SearchIconWithIcon from "../../SearchIconWithIcon/SearchIconWithIcon";
import useFocusShortcut from "../../../../../utils/useFocusShortcut";
import { clearDoc } from "@src/slices/docsSlices";
// import KIcon from "../../../assets/KIcon.svg";
import lIcon from "../../../assets/lIcon.svg";
import { ReactComponent as RedTrash } from "../../../assets/redTrash.svg";
import { ReactComponent as Phone } from "../../../assets/phoneIcon.svg";
import { ReactComponent as GreenMailIcon } from "../../../assets/greenMailIcon.svg";
import { ReactComponent as GreenWebIcon } from "../../../assets/greenWebIcon.svg";
import { ReactComponent as GreenPhoneIcon } from "../../../assets/greenPhoneIcon.svg";
import { ReactComponent as GrayTagIcon } from "../../../assets/tagNewIcon.svg";
import { ReactComponent as GreenCopyIcon } from "../../../assets/greenCopyIcon.svg";
import { ReactComponent as LocationParamIcon } from "../../../assets/LocationParamIcon.svg";
// import { ReactComponent as Pencil } from "../../../assets/pencilEdit.svg";
// import { ReactComponent as BlackCheckboxIcon } from "../../../assets/blackCheckboxIcon.svg";
import { ReactComponent as ArrowDown } from "../../../assets/arrowDownGray.svg";
// import { ReactComponent as AddBlack } from "../../../assets/addBlack.svg";
// import { ReactComponent as EyePassword } from "../../../assets/eyePassword.svg";
// import { ReactComponent as WhiteXCloseIcon } from "../../../assets/WhiteXCloseIcon.svg";
// import { ReactComponent as EyePasswordSlash } from "../../../assets/eyePasswordSlash.svg";
import ItemNavigation from "../ItemNavigation/ItemNavigation";
import { ReactComponent as ContactIdentification } from "../../../assets/contactIdentificationIcon.svg";
import { ReactComponent as BillingDetailIcon } from "../../../assets/billingDetailIcon.svg";
import { ReactComponent as ParametersIcon } from "../../../assets/parametersIcon.svg";
import { ReactComponent as IconForSee } from "../../../assets/iconForSee.svg";
// import { ReactComponent as PencilForPopup } from "../../../assets/pencilForPopup.svg";
import { ReactComponent as FilterIcon1InExplore } from "../../../assets/filterIcon1InExplore.svg"
import k from "../../../assets/k.svg";
import { ReactComponent as ComplementaryAndSubstitute } from "../../../assets/complementaryAndSubstituteIcon.svg";
import SortableItem from './SortableItem.jsx'
import QRCodeGenerator from "../../QRCodeGenerator/QRCodeGenerator";
import { useLocation, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { createVariable, getVariable } from "../../../../../actions/user";
import ProfileModalTemplate from "../../ProfileModalTemplate/ProfileModalTemplate";
import DeleteButton from "../../DeleteButton/DeleteButton";
import { setCurrentTableNew } from "../../../../../slices/userSlices.js";

const ContactAssetNavigation = ({
  type,
  setParameters,
  parameters,
  newContact,
  handleDelete,
  text,
  setShowCreateParameter,
  showCreateParameter,
  data,
  // setData,
  setImage,
  handleBtnsActions,
  setShowAddTags,
  showAddTags,
  copyClipboard,
  // setSelectedTags,
  setTypeLocation,
  setLocationState,
  typeContainer,
  father,
  parametersRef,
  billingRef,
  contactRef,
  assetRef,
  financialRef,
  complementaryRef,
  parameterAssetRef,
  contactId,
  setShowCreateParameterFromPopup,
  tableType,
  contactTableId,
  assetTableId
}) => {
  const [t] = useTranslation("Contacts");
  const [isParametersVisible, setIsParameterVisible] = useState(true);
  const [activeId, setActiveId] = useState(null);

  const location = useLocation()
  const navigate = useNavigate()
  const [showButtonAdd, setShowButtonAdd] = useState(false)
  const { tableView,currentTableNew } = useSelector(state => state.user)
  const [showEye, setShowEye] = useState(false)
  const [showEyes, setShowEyes] = useState(false)

  const dispatch = useDispatch()

  // console.log('esto es tableView',tableView)

  // console.log('esto es contactTableId',contactTableId)


  const addParameterColumn = async (parameter, id, type) => {


    const now = new Date().toISOString();
    if (location?.pathname?.split("/")?.find(path => path == "assets") || tableType == "assets") {
      if (!(tableView?.tables?.[assetTableId]?.find(param => param.key == parameter))) {
        // console.log('esto es tables',tableView)
        // console.log('esto es assetTableId',assetTableId)
        // console.log('esto es tableView?.tables?.[assetTableId]',tableView?.tables?.[assetTableId])
        const index = tableView?.parametersTables?.[assetTableId]?.findIndex(param => param.id == id)
        dispatch(setCurrentTableNew([...currentTableNew, assetTableId]))
        await dispatch(createVariable({
          variableData: {
            category: "tableView",
            title: "tableView",
            type: "tableView",
            tables: {
              ...tableView?.tables,
              [assetTableId]: [{
                label: parameter,
                key: parameter,
                createdAt: now,
                hidden: false,
                type: type
              },
              ...tableView?.tables?.[assetTableId]
              ]
            },
            parametersTables: {
              ...tableView?.parametersTables,
              [assetTableId]: tableView.parametersTables[assetTableId].map((item, i) =>
                i === index ? { ...item, hidden: false } : item
              )
            }
          }
        }))
      }
      else if (!(tableView?.assets?.find(param => param.key == parameter))) {
        const index = tableView?.parametersAssets?.findIndex(param => param.id == id)

        await dispatch(createVariable({
          variableData: {
            category: "tableView", title: "tableView", type: "tableView", assets: [{ label: parameter, key: parameter, createdAt: now, hidden: false }, ...tableView.assets],
            parametersAssets: tableView.parametersAssets.map((item, i) =>
              i === index ? { ...item, hidden: false } : item)

          }
        }))
      }
    }
    else if (location?.pathname?.split("/")?.find(path => path == "contacts") || tableType == "contacts") {
      if (!(tableView?.tables?.[contactTableId]?.find(param => param.key == parameter))) {
        const index = tableView?.parametersTables?.[contactTableId]?.findIndex(param => param.id == id)
        dispatch(setCurrentTableNew([...currentTableNew, contactTableId]))
        // console.log('esto es tableView?.tables?.[contactTableId]',tableView?.tables?.[contactTableId])

        // if(tableView?.tables?.[contactTableId]?.length > 0){
        await dispatch(createVariable({
          variableData: {
            category: "tableView", title: "tableView", type: "tableView", tables: { ...tableView?.tables, [contactTableId]: [{ label: parameter, key: parameter, createdAt: now, hidden: false, type: type },  ...tableView?.tables?.[contactTableId]] },
            parametersTables: {
              ...tableView?.parametersTables, [contactTableId]: tableView.parametersTables[contactTableId].map((item, i) =>
                i === index ? { ...item, hidden: false } : item
              )
            }
          }
        }))
      // }
        // else {
        //   await dispatch(createVariable({
        //     variableData: {
        //       category: "tableView", title: "tableView", type: "tableView", tables: { ...tableView?.tables, [contactTableId]: [{ label: parameter, key: parameter, createdAt: now, hidden: false, type: type }] },
        //       parametersTables: {
        //         ...tableView?.parametersTables, [contactTableId]: tableView.parametersTables[contactTableId].map((item, i) =>
        //           i === index ? { ...item, hidden: false } : item
        //         )
        //       }
        //     }
        //   }))
        // }



      }
      else if (!(tableView?.contacts?.find(param => param.key == parameter))) {
        const index = tableView?.parametersContacts?.findIndex(param => param.id == id)

        await dispatch(createVariable({
          variableData: {
            category: "tableView", title: "tableView", type: "tableView", contacts: [{ label: parameter, key: parameter, createdAt: now, hidden: false }, ...tableView.contacts],
            parametersContacts: tableView.parametersContacts.map((item, i) =>
              i === index ? { ...item, hidden: false } : item
            )
          }
        }))
      }
    }
    await dispatch(getVariable({ type: 'tableView' }))

  }


  const handleHidden = async (boolean, parameter) => {
    if (location?.pathname?.split("/")?.find(path => path == "assets") || tableType == "assets") {

      if (assetTableId) {

        const index = tableView?.tables?.[assetTableId]?.findIndex(param => param.key === parameter.name)

        let newTable = [...tableView.tables?.[assetTableId]]
        newTable[index] = { ...newTable[index], hidden: boolean }

        const parameterIndex = tableView?.parametersTables[assetTableId]?.findIndex(param => param.id == parameter.id)

        if (index !== -1) {
          await dispatch(createVariable({
            variableData: {
              category: "tableView", title: "tableView", type: "tableView", tables: { ...tableView.tables, [assetTableId]: [...newTable] },
              parametersTables: {
                ...tableView.parametersTables, [assetTableId]: tableView.parametersTables[assetTableId].map((item, i) =>
                  i === parameterIndex ? { ...item, hidden: boolean } : item
                )
              }
            }
          }))
        }

      } else {

        const index = tableView?.assets.findIndex(param => param.key === parameter.name)

        let newAssets = [...tableView.assets]
        newAssets[index] = { ...newAssets[index], hidden: boolean }


        const parameterIndex = tableView?.parametersAssets.findIndex(param => param.id == parameter.id)

        if (index !== -1) {
          await dispatch(createVariable({
            variableData: {
              category: "tableView", title: "tableView", type: "tableView", assets: [...newAssets],
              parametersAssets: tableView.parametersAssets.map((item, i) =>
                i === parameterIndex ? { ...item, hidden: boolean } : item
              )
            }
          }))
        }
      }
    }
    else if (location?.pathname?.split("/")?.find(path => path == "contacts") || tableType == "contacts") {

      if (contactTableId) {

        const index = tableView?.tables?.[contactTableId].findIndex(param => param.key === parameter.name)

        let newTable = [...tableView.tables?.[contactTableId]]
        newTable[index] = { ...newTable[index], hidden: boolean }

        const parameterIndex = tableView?.parametersTables[contactTableId].findIndex(param => param.id == parameter.id)

        if (index !== -1) {
          await dispatch(createVariable({
            variableData: {
              category: "tableView", title: "tableView", type: "tableView", tables: { ...tableView.tables, [contactTableId]: [...newTable] },
              parametersTables: {
                ...tableView.parametersTables, [contactTableId]: tableView.parametersTables[contactTableId].map((item, i) =>
                  i === parameterIndex ? { ...item, hidden: boolean } : item
                )
              }
            }
          }))
        }

      } else {
        const index = tableView?.contacts.findIndex(param => param.key === parameter.name)

        let newContacts = [...tableView.contacts]
        newContacts[index] = { ...newContacts[index], hidden: boolean }

        const parameterIndex = tableView?.parametersContacts.findIndex(param => param.id == parameter.id)

        if (index !== -1) {
          await dispatch(createVariable({
            variableData: {
              category: "tableView", title: "tableView", type: "tableView", contacts: [...newContacts],
              parametersContacts: tableView.parametersContacts.map((item, i) =>
                i === parameterIndex ? { ...item, hidden: boolean } : item
              )
            }
          }))
        }
      }

    }
    await dispatch(getVariable({ type: 'tableView' }))

  }


  const handleClick = (id) => {
    setActiveId(id);
  };

  const renderLinks = (items) =>
    items.map(({ id, label }) => (
      <li
        key={id}
        onClick={() => handleClick(id)}
        className={activeId === id ? styles.active : ""}
      >
        <a href={`#${id}`}>{label}</a>
      </li>
    ));



  const contactItems = [
    { id: "contactIdentification", label: t('contactIdentification'), Icon: ContactIdentification, ref: contactRef },
    { id: "billingDetails", label: t('billingDetails'), Icon: BillingDetailIcon, ref: billingRef },
    { id: "parameters", label: t('parameters'), Icon: ParametersIcon, ref: parametersRef },
  ];

  const assetItems = [
    { id: "assetIdentification", label: t('assetIdentification'), Icon: ContactIdentification, ref: assetRef },
    { id: "financialInformation", label: t('financialInformation'), Icon: BillingDetailIcon, ref: financialRef },
    { id: "complementaryAndSubstitute", label: t('complementaryAndSubstitute'), Icon: ComplementaryAndSubstitute, ref: complementaryRef },
    { id: "parameters", label: t('parameters'), Icon: ParametersIcon, ref: parameterAssetRef },
  ];

  const addParameter = () => {
    // console.log('esta entrando al addParameter')
    if (typeof showCreateParameter !== "undefined") {
      if (typeContainer == "popup") setShowCreateParameterFromPopup(true)
      else setShowCreateParameter(true);
    } else {
      setParameters((prev) => ({
        ...prev,
        parameters: [
          ...prev.parameters,
          { name: "", value: "", title: "", id: Date.now().toString(36) + Math.random().toString(36) },
        ],
      }));
    }
  };

// console.log('parameters', parameters)

  useEffect(() => {

    if (location?.pathname?.split("/")?.find(path => path == "assets") || tableType == "assets") {

      if (assetTableId) {


        let newParameters = []
        tableView?.parametersTables?.[assetTableId]?.forEach(parameter => {
          newParameters = [...newParameters, parameter]
        })

        const ordenado = newParameters.sort((a, b) => {
          const getPriority = (item) => {
            if (item.hasOwnProperty("hidden")) {
              return item.hidden ? 1 : 0;
            }
            return 2;
          };

          return getPriority(a) - getPriority(b);
        });
        setParameters((prev) => ({
          ...prev,
          parameters: ordenado
        }));
      } else {

        let newParameters = []
        tableView?.parametersAssets?.forEach(parameter => {
          newParameters = [...newParameters, parameter]
        })

        const ordenado = newParameters.sort((a, b) => {
          const getPriority = (item) => {
            if (item.hasOwnProperty("hidden")) {
              return item.hidden ? 1 : 0;
            }
            return 2;
          };

          return getPriority(a) - getPriority(b);
        });

        setParameters((prev) => ({
          ...prev,
          parameters: ordenado
        }));

      }

    }
    else if (location?.pathname?.split("/")?.find(path => path == "contacts") || tableType == "contacts") {
      if (contactTableId) {
        // console.log('esto es contactTableId',contactTableId)
        // console.log('esto es  tableView?.parametersTables?', tableView?.parametersTables)

        let newParameters = []
        tableView?.parametersTables?.[contactTableId]?.forEach(parameter => {
          newParameters = [...newParameters, parameter]
        })

        const ordenado = newParameters.sort((a, b) => {
          const getPriority = (item) => {
            if (item.hasOwnProperty("hidden")) {
              return item.hidden ? 1 : 0;
            }
            return 2;
          };

          return getPriority(a) - getPriority(b);
        });
        setParameters((prev) => ({
          ...prev,
          parameters: ordenado
        }));
      } else {
        // console.log("no entra aca o si")
        let newParameters = []
        tableView?.parametersContacts?.forEach(parameter => {
          newParameters = [...newParameters, parameter]
        })

        const ordenado = newParameters.sort((a, b) => {
          const getPriority = (item) => {
            if (item.hasOwnProperty("hidden")) {
              return item.hidden ? 1 : 0;
            }
            return 2;
          };

          return getPriority(a) - getPriority(b);
        });
        setParameters((prev) => ({
          ...prev,
          parameters: ordenado
        }));
      }
    }

  },
    [
      // ✅ Dependencias seguras:
      tableView?.parametersContacts,
      tableView?.parametersAssets,
      tableView?.parametersTables, // ← Solo hasta el objeto, NO usamos [contactTableId] aquí
      contactTableId,
      tableType,
      location.pathname
    ]);
  //  [tableView?.parametersContacts, tableView?.parametersAssets,tableView?.parametersTables[contactTableId]])

  useEffect(() => {
    if (location?.pathname?.split("/")?.find(path => path === "assets") || tableType == "assets") {
      if (tableView.title === "tableView") {
        if (tableView?.parametersTables?.[assetTableId]?.length == 0 || tableView?.parametersTables?.[assetTableId] === undefined) {
          const fnContacts = async () => {
            await dispatch(createVariable({
              variableData: {
                category: "tableView", title: "tableView", type: "tableView", parametersTables:
                {
                  ...tableView.parametersTables, [assetTableId]:
                    [
                      { name: "Precio Maximo", delete: true, noDelete: true, value: "", title: "", id: Date.now().toString(36) + Math.random().toString(36) },
                      { name: "Precio Minimo", delete: true, noDelete: true, value: "", title: "", id: Date.now().toString(36) + Math.random().toString(36) },
                      { name: "Precio Medio", delete: true, noDelete: true, value: "", title: "", id: Date.now().toString(36) + Math.random().toString(36) },
                      { name: "Categoria", delete: true, noDelete: true, value: "", title: "", id: Date.now().toString(36) + Math.random().toString(36) },
                    ]
                }
              }
            }))

            await dispatch(getVariable({ type: 'tableView' }))
          }
          fnContacts()

        }
        else if (tableView?.parametersAssets?.length == 0 || tableView?.parametersAssets === undefined) {
          const fnAssets = async () => {
            await dispatch(createVariable({
              variableData: {
                category: "tableView", title: "tableView", type: "tableView", parametersAssets: [
                  { name: "Precio Maximo", delete: true, noDelete: true, value: "", title: "", id: Date.now().toString(36) + Math.random().toString(36) },
                  { name: "Precio Minimo", delete: true, noDelete: true, value: "", title: "", id: Date.now().toString(36) + Math.random().toString(36) },
                  { name: "Precio Medio", delete: true, noDelete: true, value: "", title: "", id: Date.now().toString(36) + Math.random().toString(36) },
                  { name: "Categoria", delete: true, noDelete: true, value: "", title: "", id: Date.now().toString(36) + Math.random().toString(36) },
                ]
              }
            }))

            await dispatch(getVariable({ type: 'tableView' }))
          }
          fnAssets()

        }
      }

    } else if (location?.pathname?.split("/")?.find(path => path === "contacts") || tableType == "contacts") {
      if (tableView.title === "tableView") {
        if (tableView?.parametersTables?.[contactTableId]?.length == 0 || tableView?.parametersTables?.[contactTableId] === undefined) {
          const fnContacts = async () => {
            await dispatch(createVariable({
              variableData: {
                category: "tableView", title: "tableView", type: "tableView", parametersTables:
                {
                  ...tableView.parametersTables, [contactTableId]:
                    [
                      { name: "Dirección", delete: true, noDelete: true, value: "", title: "", id: Date.now().toString(36) + Math.random().toString(36) },
                      { name: "Teléfono", delete: true, noDelete: true, value: "", title: "", id: Date.now().toString(36) + Math.random().toString(36) },
                      { name: "Localidad", delete: true, noDelete: true, value: "", title: "", id: Date.now().toString(36) + Math.random().toString(36) },
                      { name: "País", delete: true, noDelete: true, value: "", title: "", id: Date.now().toString(36) + Math.random().toString(36) },
                    ]
                }
              }
            }))

            await dispatch(getVariable({ type: 'tableView' }))
          }
          fnContacts()

        }
        else if (tableView?.parametersContacts?.length == 0 || tableView?.parametersContacts === undefined) {
          const fnContacts = async () => {
            await dispatch(createVariable({
              variableData: {
                category: "tableView", title: "tableView", type: "tableView", parametersContacts: [
                  { name: "Dirección", delete: true, noDelete: true, value: "", title: "", id: Date.now().toString(36) + Math.random().toString(36) },
                  { name: "Teléfono", delete: true, noDelete: true, value: "", title: "", id: Date.now().toString(36) + Math.random().toString(36) },
                  { name: "Localidad", delete: true, noDelete: true, value: "", title: "", id: Date.now().toString(36) + Math.random().toString(36) },
                  { name: "País", delete: true, noDelete: true, value: "", title: "", id: Date.now().toString(36) + Math.random().toString(36) },
                ]
              }
            }))

            await dispatch(getVariable({ type: 'tableView' }))
          }
          fnContacts()

        }

      }
    }
  }, [tableView]);


  useEffect(() => {

    if (location?.pathname?.split("/")?.find(path => path === "assets") || tableType == "assets") {
      if (assetTableId) {
        if (tableView?.parametersTables?.[assetTableId]?.length > 0 && parameters?.length !== tableView?.parametersTables?.[assetTableId]?.length) {
          let newParameters = []
          tableView?.parametersTables?.[assetTableId]?.forEach(parameter => {
            newParameters = [...newParameters, parameter]
          })

          const ordenado = newParameters.sort((a, b) => {
            const getPriority = (item) => {
              if (item.hasOwnProperty("hidden")) {
                return item.hidden ? 1 : 0;
              }
              return 2;
            };


            return getPriority(a) - getPriority(b);
          });

          setParameters((prev) => ({
            ...prev,
            parameters: ordenado
          }));


          // }
        }
      } else {

        if (parameters?.length !== tableView?.parametersAssets?.length) {

          let newParameters = []
          tableView?.parametersAssets?.forEach(parameter => {
            newParameters = [...newParameters, parameter]
          })

          const ordenado = newParameters.sort((a, b) => {
            const getPriority = (item) => {
              if (item.hasOwnProperty("hidden")) {
                return item.hidden ? 1 : 0;
              }
              return 2;
            };

            return getPriority(a) - getPriority(b);
          });

          setParameters((prev) => ({
            ...prev,
            parameters: ordenado
          }));



        }
      }

    } else if (location?.pathname?.split("/")?.find(path => path === "contacts") || tableType == "contacts") {
      if (contactTableId) {
        // console.log('esto es tableView?.parametersTables?.[assetTableId]?.length',tableView?.parametersTables?.[assetTableId]?.length)
        // console.log('esto es parameters?.length',parameters?.length)
        if (tableView?.parametersTables?.[contactTableId]?.length > 0 && parameters?.length !== tableView?.parametersTables?.[contactTableId]?.length) {

          let newParameters = []
          tableView?.parametersTables?.[contactTableId]?.forEach(parameter => {
            newParameters = [...newParameters, parameter]
          })

          const ordenado = newParameters.sort((a, b) => {
            const getPriority = (item) => {
              if (item.hasOwnProperty("hidden")) {
                return item.hidden ? 1 : 0;
              }
              return 2;
            };


            return getPriority(a) - getPriority(b);
          });

          setParameters((prev) => ({
            ...prev,
            parameters: ordenado
          }));


          // }
        }
      }

      else {
        if (parameters?.length !== tableView?.parametersContacts?.length) {

          let newParameters = []
          tableView?.parametersContacts?.forEach(parameter => {
            newParameters = [...newParameters, parameter]
          })

          const ordenado = newParameters.sort((a, b) => {
            const getPriority = (item) => {
              if (item.hasOwnProperty("hidden")) {
                return item.hidden ? 1 : 0;
              }
              return 2;
            };


            return getPriority(a) - getPriority(b);
          });

          setParameters((prev) => ({
            ...prev,
            parameters: ordenado
          }));


          // }
        }
      }
    }

  }, [parameters]);

  const [searchTerm, setSearchTerm] = useState("");

  const searchInputRef = useRef(null);



  useFocusShortcut(searchInputRef, "/");

  const sensors = useSensors(useSensor(PointerSensor));

  const filteredParameters = parameters?.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over) return;

    if (active.id !== over.id) {
      const oldIndex = parameters.findIndex((p) => p.id === active.id);
      const newIndex = parameters.findIndex((p) => p.id === over.id);

      const reordered = arrayMove(parameters, oldIndex, newIndex);
      setParameters((prev) => ({
        ...prev,
        parameters: reordered
      }));

      if (location?.pathname?.split("/")?.find(path => path == "assets") || tableType == "assets") {
        if (assetTableId) {
          const fn = async () => {
            await dispatch(createVariable({
              variableData: {
                category: "tableView", title: "tableView",
                type: "tableView",
                parametersTables: { ...tableView.parametersTables, [assetTableId]: reordered }
              }
            }));
            dispatch(getVariable({ type: 'tableView' }))
          }
          fn()
        }
        else {
          const fn = async () => {
            await dispatch(createVariable({
              variableData: {
                category: "tableView", title: "tableView",
                type: "tableView",
                parametersAssets: reordered
              }
            }));
            dispatch(getVariable({ type: 'tableView' }))
          }
          fn()
        }
      }
      else if (location?.pathname?.split("/")?.find(path => path == "contacts") || tableType == "contacts") {

        if (contactTableId) {
          const fn = async () => {
            await dispatch(createVariable({
              variableData: {
                category: "tableView", title: "tableView",
                type: "tableView",
                parametersTables: { ...tableView.parametersTables, [contactTableId]: reordered }
              }
            }));
            dispatch(getVariable({ type: 'tableView' }))
          }
          fn()
        } else {

          const fn = async () => {
            await dispatch(createVariable({
              variableData: {
                category: "tableView", title: "tableView",
                type: "tableView",
                parametersContacts: reordered
              }
            }));
            dispatch(getVariable({ type: 'tableView' }))
          }
          fn()
        }
      }
    }
  };

  const [arrayText, setArrayText] = useState(
    [{ name: "Sin categoria (1)", id: 'cat1' }, { name: "Texto", id: "texto1" }, { name: "Texto", id: "texto2" }, { name: "Texto", id: "texto3" }, { name: "Texto", id: "texto4" }]
  )

  const handleDragEndText = (event) => {
    const { active, over } = event;
    if (!over) return;

    if (active.id !== over.id) {
      const oldIndex = arrayText.findIndex((p) => p.id === active.id);
      const newIndex = arrayText.findIndex((p) => p.id === over.id);

      const reordered = arrayMove(arrayText, oldIndex, newIndex);
      setArrayText(reordered);
    }
  };


  const deleteParameter = async (parameter) => {
    if (location?.pathname?.split("/")?.find(path => path == "assets") || tableType == "assets") {

      if (assetTableId) {

        if (tableView?.tables?.[assetTableId]?.find(param => param.key == parameter.name)) {
          const newContacts = tableView.tables?.[assetTableId].filter(param => param.key !== parameter.name)
          const parameterIndex = tableView?.parametersTables?.[assetTableId].findIndex(param => param.id == parameter.id)

          await dispatch(createVariable({
            variableData: {
              category: "tableView", title: "tableView", type: "tableView", tables: { ...tableView.tables, [assetTableId]: [...newContacts] },
              parametersTables: {
                ...tableView.parametersTables, [assetTableId]: tableView.parametersTables[assetTableId].map((item, i) =>
                  i === parameterIndex
                    ? (() => {
                      const { hidden, ...rest } = item;
                      return { ...rest, delete: true };
                    })()
                    : item
                )
              }
            }
          }))
        } else {
          const parameterIndex = tableView?.parametersTables?.[assetTableId].findIndex(param => param.id == parameter.id)
          await dispatch(createVariable({
            variableData: {
              category: "tableView", title: "tableView", type: "tableView",
              parametersTables: {
                ...tableView.parametersTables, [assetTableId]: tableView.parametersTables[assetTableId].map((item, i) =>
                  i === parameterIndex
                    ? (() => {
                      const { hidden, ...rest } = item;
                      return { ...rest, delete: true };
                    })()
                    : item
                )
              }
            }
          }))
        }

      } else {

        if (tableView?.assets?.find(param => param.key == parameter.name)) {
          const newAssets = tableView.contacts.filter(param => param.key !== parameter.name)
          const parameterIndex = tableView?.parametersAssets.findIndex(param => param.id == parameter.id)
          // const newParameters = tableView.parametersAssets.filter(param => param.name !== parameter.name)

          await dispatch(createVariable({
            variableData: {
              category: "tableView",
              title: "tableView",
              type: "tableView",
              assets: [...newAssets],
              parametersAssets: tableView.parametersAssets.map((item, i) =>
                i === parameterIndex
                  ? (() => {
                    const { hidden, ...rest } = item;
                    return { ...rest, delete: true };
                  })()
                  : item
              )
            }
          }));
        } else {
          const parameterIndex = tableView?.parametersAssets.findIndex(param => param.id == parameter.id)

          await dispatch(createVariable({
            variableData: {
              category: "tableView", title: "tableView", type: "tableView",
              parametersAssets: tableView.parametersAssets.map((item, i) =>
                i === parameterIndex
                  ? (() => {
                    const { hidden, ...rest } = item;
                    return { ...rest, delete: true };
                  })()
                  : item
              )
            }
          }))
        }
      }
    }
    else if (location?.pathname?.split("/")?.find(path => path == "contacts") || tableType == "contacts") {
      if (contactTableId) {

        if (tableView?.tables?.[contactTableId]?.find(param => param.key == parameter.name)) {
          const newContacts = tableView.tables?.[contactTableId].filter(param => param.key !== parameter.name)
          const parameterIndex = tableView?.parametersTables?.[contactTableId].findIndex(param => param.id == parameter.id)

          await dispatch(createVariable({
            variableData: {
              category: "tableView", title: "tableView", type: "tableView", tables: { ...tableView.tables, [contactTableId]: [...newContacts] },
              parametersTables: {
                ...tableView.parametersTables, [contactTableId]: tableView.parametersTables[contactTableId].map((item, i) =>
                  i === parameterIndex
                    ? (() => {
                      const { hidden, ...rest } = item;
                      return { ...rest, delete: true };
                    })()
                    : item
                )
              }
            }
          }))
        } else {
          const parameterIndex = tableView?.parametersTables?.[contactTableId].findIndex(param => param.id == parameter.id)
          await dispatch(createVariable({
            variableData: {
              category: "tableView", title: "tableView", type: "tableView",
              parametersTables: {
                ...tableView.parametersTables, [contactTableId]: tableView.parametersTables[contactTableId].map((item, i) =>
                  i === parameterIndex
                    ? (() => {
                      const { hidden, ...rest } = item;
                      return { ...rest, delete: true };
                    })()
                    : item
                )
              }
            }
          }))
        }

      } else {


        if (tableView?.contacts?.find(param => param.key == parameter.name)) {
          const newContacts = tableView.contacts.filter(param => param.key !== parameter.name)
          const parameterIndex = tableView?.parametersContacts.findIndex(param => param.id == parameter.id)

          await dispatch(createVariable({
            variableData: {
              category: "tableView", title: "tableView", type: "tableView", contacts: [...newContacts],
              parametersContacts: tableView.parametersContacts.map((item, i) =>
                i === parameterIndex
                  ? (() => {
                    const { hidden, ...rest } = item;
                    return { ...rest, delete: true };
                  })()
                  : item
              )
            }
          }))
        } else {
          const parameterIndex = tableView?.parametersContacts.findIndex(param => param.id == parameter.id)
          await dispatch(createVariable({
            variableData: {
              category: "tableView", title: "tableView", type: "tableView",
              parametersContacts: tableView.parametersContacts.map((item, i) =>
                i === parameterIndex
                  ? (() => {
                    const { hidden, ...rest } = item;
                    return { ...rest, delete: true };
                  })()
                  : item
              )
            }
          }))
        }
      }

    }

    await dispatch(getVariable({ type: 'tableView' }))
  }


  const addParameterVisibleList = async (parameter) => {

    if (location?.pathname?.split("/")?.find(path => path == "assets") || tableType == "assets") {
      if (assetTableId) {
        const parameterIndex = tableView?.parametersTables?.[assetTableId].findIndex(param => param.id == parameter.id)

        await dispatch(createVariable({
          variableData: {
            category: "tableView", title: "tableView", type: "tableView",
            parametersTables: {
              ...tableView.parametersTables, [assetTableId]: tableView?.parametersTables[assetTableId].map((item, i) =>
                i === parameterIndex ? { ...item, delete: false } : item
              )
            }
          }
        }))

      } else {
        const parameterIndex = tableView?.parametersAssets.findIndex(param => param.id == parameter.id)

        await dispatch(createVariable({
          variableData: {
            category: "tableView", title: "tableView", type: "tableView",
            parametersAssets: tableView.parametersAssets.map((item, i) =>
              i === parameterIndex ? { ...item, delete: false } : item
            )
          }
        }))
      }
    }
    else if (location?.pathname?.split("/")?.find(path => path == "contacts") || tableType == "contacts") {

      if (contactTableId) {
        const parameterIndex = tableView?.parametersTables?.[contactTableId].findIndex(param => param.id == parameter.id)

        await dispatch(createVariable({
          variableData: {
            category: "tableView", title: "tableView", type: "tableView",
            parametersTables: {
              ...tableView.parametersTables, [contactTableId]: tableView?.parametersTables[contactTableId].map((item, i) =>
                i === parameterIndex ? { ...item, delete: false } : item
              )
            }
          }
        }))

      } else {


        const parameterIndex = tableView?.parametersContacts.findIndex(param => param.id == parameter.id)

        await dispatch(createVariable({
          variableData: {
            category: "tableView", title: "tableView", type: "tableView",
            parametersContacts: tableView.parametersContacts.map((item, i) =>
              i === parameterIndex ? { ...item, delete: false } : item
            )
          }
        }))
      }
    }
    await dispatch(getVariable({ type: 'tableView' }))
  }

  const handleGetOneContact = async (contactId) => {
    try {
      navigate(`/admin/docs/${contactId}`);
    } catch (error) {
      console.error("Error al obtener el contacte:", error);
    }
  };


  const deleteParameterDB = async (parameter) => {


    if (location?.pathname?.split("/")?.find(path => path == "assets") || tableType == "assets") {

      if (assetTableId) {
        if (tableView?.tables?.[assetTableId]?.find(param => param.key == parameter.name)) {
          const newContacts = tableView.tables?.[assetTableId].filter(param => param.key !== parameter.name)
          const newParameters = tableView?.parametersTables[assetTableId].filter(param => param.id != parameter.id)

          await dispatch(createVariable({
            variableData: {
              category: "tableView", title: "tableView", type: "tableView", tables: { ...tableView.tables, [assetTableId]: [...newContacts] },
              parametersTables: { ...tableView.parametersTables, [assetTableId]: newParameters }
            }
          }))
        } else {

          const newParameters = tableView?.parametersTables[assetTableId].filter(param => param.id != parameter.id)
          await dispatch(createVariable({
            variableData: {
              category: "tableView", title: "tableView", type: "tableView",
              parametersTables: { ...tableView.parametersTables, [assetTableId]: newParameters }
            }
          }))
        }
      } else {

        if (tableView?.assets?.find(param => param.key == parameter.name)) {
          const newAssets = tableView.contacts.filter(param => param.key !== parameter.name)
          const newParameters = tableView?.parametersAssets.filter(param => param.id != parameter.id)

          await dispatch(createVariable({
            variableData: {
              category: "tableView",
              title: "tableView",
              type: "tableView",
              assets: [...newAssets],
              parametersAssets: newParameters
            }
          }));
        } else {
          const newParameters = tableView?.parametersAssets.filter(param => param.id != parameter.id)
          await dispatch(createVariable({
            variableData: {
              category: "tableView", title: "tableView", type: "tableView",
              parametersAssets: newParameters
            }
          }))
        }
      }
    }
    else if (location?.pathname?.split("/")?.find(path => path == "contacts") || tableType == "contacts") {

      if (contactTableId) {
        if (tableView?.tables?.[contactTableId]?.find(param => param.key == parameter.name)) {
          const newContacts = tableView.tables?.[contactTableId].filter(param => param.key !== parameter.name)
          const newParameters = tableView?.parametersTables[contactTableId].filter(param => param.id != parameter.id)

          await dispatch(createVariable({
            variableData: {
              category: "tableView", title: "tableView", type: "tableView", tables: { ...tableView.tables, [contactTableId]: [...newContacts] },
              parametersTables: { ...tableView.parametersTables, [contactTableId]: newParameters }
            }
          }))
        } else {

          const newParameters = tableView?.parametersTables[contactTableId].filter(param => param.id != parameter.id)
          await dispatch(createVariable({
            variableData: {
              category: "tableView", title: "tableView", type: "tableView",
              parametersTables: { ...tableView.parametersTables, [contactTableId]: newParameters }
            }
          }))
        }
      } else {
        if (tableView?.contacts?.find(param => param.key == parameter.name)) {
          const newContacts = tableView.contacts.filter(param => param.key !== parameter.name)
          const newParameters = tableView?.parametersContacts.filter(param => param.id != parameter.id)

          await dispatch(createVariable({
            variableData: {
              category: "tableView", title: "tableView", type: "tableView", contacts: [...newContacts],
              parametersContacts: newParameters
            }
          }))
        } else {

          const newParameters = tableView?.parametersContacts.filter(param => param.id != parameter.id)
          await dispatch(createVariable({
            variableData: {
              category: "tableView", title: "tableView", type: "tableView",
              parametersContacts: newParameters
            }
          }))
        }
      }


    }

    await dispatch(getVariable({ type: 'tableView' }))

  }

  return (
    <div className={styles.ContactAssetNavigation}>
      <ProfileModalTemplate
        type={typeContainer}
        image={data.image}
        handleContactData={setImage}
        id={data._id}
        sticky={true}
        customStyle={{
          width: "150px",
          height: "150px",
          borderRadius: typeContainer === "popup" && father === "asset" && "8px"
        }}
      />
      <div className={styles.dataInfo}>
        <p>
          {type === "contact"
            ? data.contactName || t("contactName")
            : data.name || t("assetName")}
        </p>

        <span>
          {type === "contact" ? data.type || t("contactType") : data.type || t("assetType")}
        </span>

      </div>
      {type === 'contact' ? (
        <div className={styles.btnContactInfoContainer}>
          <Button
            type="border"
            action={() => handleBtnsActions("clipboard")}
          >
            <GreenCopyIcon
              className={copyClipboard && styles.activeBtn}
            />
          </Button>
          <Button
            type="border"
            action={() => {
              setShowAddTags(true);
            }}
          >
            <GrayTagIcon
              className={showAddTags && styles.activeBtn}
            />
          </Button>
          {data?.companyPhoneNumber?.length > 0 && (
            <Button
              type="border"
              action={() => handleBtnsActions("callPhoneNumber")}
            >
              <GreenPhoneIcon />
            </Button>
          )}
          {data?.webSite && (
            <Button
              type="border"
              action={() => handleBtnsActions("website")}
            >
              <GreenWebIcon />
            </Button>
          )}
          {data?.companyEmail && (
            <Button
              type="border"
              action={() => handleBtnsActions("email")}
            >
              <GreenMailIcon />
            </Button>
          )}
        </div>
      ) : (

        <div className={styles.btnContactInfoContainer}>

          <Button
            type="border"
            action={() => handleBtnsActions("clipboard")}
          >
            <GreenCopyIcon
              className={copyClipboard && styles.activeBtn}
            />
          </Button>
          <Button
            type="border"
            action={() => {
              setShowAddTags(true);
            }}
          >
            <GrayTagIcon
              className={showAddTags && styles.activeBtn}
            />
          </Button>
          <Button
            type="border"
            action={() => {
              setTypeLocation('location')
              setLocationState(true)
            }}
          >
            <LocationParamIcon
              className={showAddTags && styles.activeBtn}
            />
          </Button>
          {/* <Button
            headerStyle={{ all: "unset", cursor: "pointer" }}
            type="border"
            action={() => console.log("")}
          >
            <PencilForPopup />
          </Button> */}
        </div>
      )}
      {typeContainer !== "popup" &&

        <SearchIconWithIcon>
          <>
            <FilterIcon1InExplore />
            <div onClick={() => searchInputRef.current.focus()}
              style={{ marginLeft: "7px" }}
              className={styles.searchIconsWrappers}
            >
              <img src={k} alt="kIcon" />
            </div>

          </>
        </SearchIconWithIcon>
      }


      {/* { typeContainer === "popup" &&
      <div style={{pointerEvents: "auto"}}>
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEndText}>
      <SortableContext items={arrayText} strategy={verticalListSortingStrategy}>
         {arrayText.map((parameter, index) => (
            <SortableItem
              key={parameter.id}
              parameter={parameter}
              index={index}
              showEyes={showEyes}
              setShowEyes={setShowEyes}
              showButtonAdd={showButtonAdd}
              setShowButtonAdd={setShowButtonAdd}
              setShowEye={setShowEye}
              showEye={showEye}
              handleHidden={handleHidden}
              addParameterColumn={addParameterColumn}
              type={typeContainer}
              deleteParameter={deleteParameter}

            />
        ))}
      </SortableContext>
      </DndContext>
      </div>
      } */}

      <div style={{ pointerEvents: "auto" }}>

        <ItemNavigation items={type === "contact" ? contactItems : assetItems}
          typeContainer={typeContainer}
          father={father}
        />
      </div>

      {
        typeContainer === "popup" &&
        <div className={styles.buttonsForSeeContainer}>
          {type === "contact" &&
            <button onClick={(e) => {
              e.stopPropagation();
              dispatch(clearDoc());
              // dispatch(
              //   setPaginationSlice({
              //     contactLimitSlice: limit,
              //     contactPageSlice: page,
              //   })
              // );
              handleGetOneContact(contactId);
            }} className={styles.buttonForSee} >

              <IconForSee /> {t('seeDocuments')} {`(${data.totalDocs})`}
            </button>
          }
          {/* <button className={styles.buttonForSee} >

      <IconForSee /> {t('seeTable')} {"(99)"}
    </button>
    <button className={styles.buttonForSee}>
      <IconForSee /> {t('seeTransactions')} {"(22)"}
    </button> */}
        </div>
      }
      <div style={{ pointerEvents: "auto" }}>

        <Button
          action={addParameter}
          type="white"
          headerStyle={{
            borderRadius: "999px",
            width: "100%",
          }}
        >
          {t("newParameterLinkeram")}
        </Button>
      </div>


      <div style={{ pointerEvents: "auto" }}>


        <SearchIconWithIcon
          ref={searchInputRef}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          classNameIconRight={styles.searchContainerL}
          onClickIconRight={() => setIsFilterOpen(true)}
          placeholder={t("searchAutomations")}
          stylesComponent={{ padding: "0" }}
        >


          <>
            <FilterIcon1InExplore />
            <div onClick={() => searchInputRef.current.focus()}
              style={{ marginLeft: "7px" }}
              className={styles.searchIconsWrappers}
            >
              <img src={k} alt="kIcon" />
            </div>

          </>
        </SearchIconWithIcon>
      </div>
      <div className={`${styles.expandableContainer} ${searchTerm.length > 0 && styles.searchOpen}`}>
        <ul>
          {/* {console.log("filteredParameters", filteredParameters)} */}
          {filteredParameters?.map((parameter, index) => {
            return <li key={parameter.id} className={styles.parameterItem}>
              {!(parameter.noDelete) && <DeleteButton action={() => deleteParameterDB(parameter)} />}
              <span>{parameter.name}</span>
              <div
                className={styles.addParameterColumn}
                onClick={() => addParameterVisibleList(parameter)}
              >
                +
              </div>
            </li>
          }).slice(0, 5)}
        </ul>
      </div>

      {/* {
  typeContainer === "popup" &&
  <div style={{ pointerEvents: "auto" }}>
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEndText}>
      <SortableContext items={arrayText} strategy={verticalListSortingStrategy}>
        {arrayText.map((parameter, index) => (
          <SortableItem
            key={parameter.id}
            parameter={parameter}
            index={index}
            showEyes={showEyes}
            setShowEyes={setShowEyes}
            showButtonAdd={showButtonAdd}
            setShowButtonAdd={setShowButtonAdd}
            setShowEye={setShowEye}
            showEye={showEye}
            handleHidden={handleHidden}
            addParameterColumn={addParameterColumn}
            type={typeContainer}
          />
        ))}
      </SortableContext>
    </DndContext>
  </div>
} */}



      <div
        className={styles.parameters}
        onClick={() => {
          setIsParameterVisible((prev) => !prev);
        }}
      >
        <ArrowDown
          style={{
            transform: isParametersVisible && "rotate(180deg)",
            transition: "all 300ms",
          }}
        />
        {t("parameters")}{" "}
        <span>
          {parameters?.length > 1 &&
            `(${parameters?.filter((item) =>
              item.name.toLowerCase().includes(searchTerm.toLowerCase()) && item.delete == false
            ).length

            })`}
        </span>
      </div>


      <div
        className={styles.parametersContainer}
        style={{
          height: isParametersVisible ? "auto" : "0px",
          overflow: "hidden",
        }}
      >
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
          <SortableContext items={filteredParameters?.length > 0 ? filteredParameters.map(p => p.id) : []} strategy={verticalListSortingStrategy}>
            <ul>
              {/* {console.log("parameters", parameters)  }
          {console.log(parameters?.filter((item) =>
            item.name.toLowerCase().includes(searchTerm.toLowerCase()) && item.delete == false
          ))} */}
              {parameters?.filter((item) =>
                item.name.toLowerCase().includes(searchTerm.toLowerCase()) && item.delete == false
              ).map((parameter, index) => (
                <SortableItem
                  key={parameter.id}
                  parameter={parameter}
                  index={index}
                  showEyes={showEyes}
                  setShowEyes={setShowEyes}
                  showButtonAdd={showButtonAdd}
                  setShowButtonAdd={setShowButtonAdd}
                  setShowEye={setShowEye}
                  showEye={showEye}
                  handleHidden={handleHidden}
                  addParameterColumn={addParameterColumn}
                  deleteParameter={deleteParameter}
                />
              ))}
            </ul>
          </SortableContext>
        </DndContext>
      </div>


      {
        !newContact && typeContainer !== "popup" && (assetTableId || contactTableId) &&  (
          <>
            <div className={styles.deleteContact} onClick={handleDelete}>
              <RedTrash className={styles.icon} /> {t("delete")} {text}
            </div>
            <QRCodeGenerator url={`https://facturagpt.com${location?.pathname}`} />
          </>

        )
      }
    </div >

  );
};

export default ContactAssetNavigation;
